const getToken = (): string => {
  const tokenFromLocalStorage = localStorage.getItem('UNEXPECTED-THUNDER') || ''

  return tokenFromLocalStorage
}

export default getToken

export const getSessionToken = (): string =>
  sessionStorage.getItem('unexpected_thunder') || ''
